import { API_URL } from "consts";
import NotFoundImg from "assets/images/not-found.png";
import type { FamiliesApiResponse, ResultItem } from "../types";

export function getSelectedResultIndex(results: ResultItem[], selectedResult: string | number): number {
  const index = results.findIndex((e) => e.config.ldc_id === selectedResult);
  return index === -1 || index >= results.length ? 0 : index;
}

export function getFamilyImage(families: FamiliesApiResponse | Record<string, never>, familyIds: string | null | undefined, resultFamilyIndex: number): string {
  if (!familyIds || !("families" in families)) return "";

  const ids = familyIds.split(",");
  const idx = families.families.findIndex((obj) => ids.includes(obj.id));
  const family = families.families[resultFamilyIndex];
  console.log("getFamilyImage()", { ids, familyIds, resultFamilyIndex, idx, family });

  return family ? API_URL + family.image : NotFoundImg;
  // return idx > -1 ? API_URL + families.families[resultFamilyIndex].image : "";
}

export function getLumRowCount(placingStyle: string | undefined): number {
  return placingStyle === "Both" || placingStyle === "Staggered" || placingStyle === "Centered" ? 2 : 1;
}
